/**
 * Calcule l'année de saison dynamiquement selon la règle :
 * - De janvier à juin : saison année-1/année
 * - De juillet à décembre : saison année/année+1
 */
export function getCurrentSeason(): string {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // getMonth() retourne 0-11
    
    if (currentMonth >= 7) {
        // De juillet à décembre : saison année/année+1
        return `${currentYear}/${currentYear + 1}`;
    } else {
        // De janvier à juin : saison année-1/année
        return `${currentYear - 1}/${currentYear}`;
    }
}

/**
 * Retourne l'année pour les inscriptions des nouveaux membres
 * - Si saison 2024/2025 : année 2024
 * - Si saison 2025/2026 : année 2025
 */
export function getRegistrationYear(): number {
    const season = getCurrentSeason();
    return parseInt(season.split('/')[0]);
}
